import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionCycleDetail() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction } = useCrudActions();

    const model = reactive({
        id: route.params?.id,
        promotionPlanId: null,
        promotionPlanName: '',
        status: null,
        startTime: null,
        endTime: null,

        get promotionPlanLink() {
            return this.promotionPlanId
                ? { name: ROUTE_NAME_PROMOTION.PLAN.DETAIL, params: { id: this.promotionPlanId } }
                : {};
        }
    });

    const fetch = executeAction({
        request: () => promotionService.cycle.get(model.id),
        onSuccess: ({ data }) => {
            data.startTime = new Date(data.startTime);
            data.endTime = new Date(data.endTime);
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.CYCLE.INDEX }),
        onFinally: () => loadAndSetPromotionPlanName()
    });

    const loadAndSetPromotionPlanName = executeAction({
        canExecute: () => model.promotionPlanId != null,
        request: () => promotionService.plan.get(model.promotionPlanId),
        onSuccess: ({ data }) => void (model.promotionPlanName = data.name)
    });

    return { model, fetch };
}
